<template>
	<div>
		<div class="page-content-wrapper">
			<div class="container-fluid">
				<div class="row">
					<div class="col-xl-2">
						<div class="card">
							<div class="card-body">
								<b-card
									no-body
									style="max-width: 20rem;"
									:img-src="jsonAlumno.imgPerfil"
									img-alt="Image"
									img-top
								></b-card>
								<br />
								<div
									class="nav flex-column nav-pills"
									role="tablist"
									aria-orientation="vertical"
								>
									<a
										@click="seleccion('SeleccionPersonal')"
										class="nav-link active mb-2"
										id="v-pills-left-home-tab"
										data-toggle="pill"
										href="#v-pills-left-home"
										role="tab"
										aria-controls="v-pills-left-home"
										aria-selected="true"
									>
										<i class="fas fa-home mr-1"></i> Información personal
									</a>
									<a
										@click="seleccion('SeleccionCurso')"
										class="nav-link mb-2"
										id="v-pills-left-profile-tab"
										data-toggle="pill"
										href="#v-pills-left-profile"
										role="tab"
										aria-controls="v-pills-left-profile"
										aria-selected="false"
									>
										<i class="fas fa-user mr-1"></i> Cursos inscritos
									</a>
									<!-- <a
										@click="seleccion('SeleccionHistorial')"
										class="nav-link mb-2"
										id="v-pills-left-messages-tab"
										data-toggle="pill"
										href="#v-pills-left-messages"
										role="tab"
										aria-controls="v-pills-left-messages"
										aria-selected="false"
									>
										<i class="far fa-envelope mr-1"></i> Historial Acceso
									</a> -->
								</div>
							</div>
						</div>
					</div>
					<!-- end col -->
					<div class="col-xl-10">
						<edicionAlumno v-if="menu.seleccionPersonal"></edicionAlumno>
						<seleccionCurso v-if="menu.seleccionCurso"></seleccionCurso>
					</div>
				</div>
			</div>
		</div>
		<toastComponent ref="toastComponent"/>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent"
import edicionAlumno from "@/components/alumno/infoPersonal/edicionAlumno";
import seleccionCurso from "@/components/alumno/cursoInscrito/seleccionCurso";
export default {
	components: {
		edicionAlumno,
		seleccionCurso,
		toastComponent
	},
	data() {
		return {
			menu: {
				seleccionPersonal: true,
				seleccionCurso: false,
				seleccionHistorial: false
			}
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"])
	},
	methods: {
		...mapActions("alumno", ["updateJsonAlumno"]),
		...mapActions("alumno", ["updateCampusJson"]),
		...mapActions("menu", ["updateMenu"]),
    ...mapActions("menu", ["updateTitulo"]),
    ...mapActions("alumno", ["updateCursoJson"]),
		seleccion(param) {
			switch (param) {
				case "SeleccionPersonal":
					this.menu.seleccionPersonal = true;
					this.menu.seleccionCurso = false;
					this.menu.seleccionHistorial = false;
					break;
				case "SeleccionCurso":
					this.menu.seleccionPersonal = false;
					this.menu.seleccionCurso = true;
					this.menu.seleccionHistorial = false;
					break;
				case "SeleccionHistorial":
					this.menu.seleccionPersonal = false;
					this.menu.seleccionCurso = false;
					this.menu.seleccionHistorial = true;
					break;
			}
		},
		getInfoAlumno(idAlumno) {
			this.axios
				.get("api/getIdAlumno/" + idAlumno)
				.then(res => {
					if (!res.data.ok) {
						let arrayToast = {
							msg: `${res.data.error}. Redireccionando...`,
							title: "Error",
							variant: "danger"
						};
						this.$refs.toastComponent.makeToast(arrayToast);

						setTimeout(() => this.$router.push({ path: "/index" }), 5000);
						return false;
					}
					this.updateJsonAlumno(res.data.alumno);
					this.getCursoAlumno(idAlumno);
					this.getCampusAlumno(idAlumno);

				})
				.catch(err => {
					console.log(err);
				});
		},
		getCampusAlumno(idAlumno) {
			this.axios
				.get("api/getCampusByAlumno/" + idAlumno)
				.then(res => {
					this.updateCampusJson(res.data.getCampus);
				})
				.catch(err => {
					console.log(err);
				});
    },
    getCursoAlumno(idAlumno) {
			this.axios
				.get("api/getCursosAlumno/" + idAlumno)
				.then(res => {
					this.updateCursoJson(res.data.getCursos);
				})
				.catch(err => {
					console.log(err);
				});
		},
	},
	mounted() {
		if (this.$route.params.idAlumno) {
			this.getInfoAlumno(this.$route.params.idAlumno);
			let menu = [
				{
					urlTolbar: "index",
					nameToolbar: "Inicio"
				},
				{
					urlTolbar: "infoAlumno/" + this.$route.params.idAlumno,
					nameToolbar: "infoAlumno"
				}
			];
			let titulo = "Panel Info Alumno";

			this.updateTitulo(titulo);
			this.updateMenu(menu);
		}
	}
};
</script>
<style scoped>
.li-info:hover {
	background-color: gainsboro;
	cursor: pointer;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #007bff !important;
}
.nav-pills .nav-link {
    border-radius: 0.25rem;
    color: #fff;
    background-color: #007bff !important;
}
</style>
